import { useColorModeValue, useIsomorphicLayoutEffect } from "../../hooks";

import { darkThemeClass } from "../../styles/themes/dark.css";
import { lightThemeClass } from "../../styles/themes/light.css";

function useTheme() {
  const themeClass = useColorModeValue(lightThemeClass, darkThemeClass);

  useIsomorphicLayoutEffect(() => {
    document.body.classList.add(themeClass);
    return () => {
      document.body.classList.remove(themeClass);
    };
  }, [themeClass]);

  return null;
}

export const ApplyTheme = () => {
  useTheme();
  return null;
};
